import React, {memo, useState} from 'react'
import AnalyseRequest from "../Components/AnalystDashboard/AnalyseRequestComponent";
import {Accordion, Button, Card, Col, Container, Form, Modal, Row} from "react-bootstrap";
import {setIndustries} from "../API/industry";
import {X} from "react-feather";
import {isHandwaiPerson} from "../Utils";

function AnalyseRequestPage() {
    const [newIndustryModal, setNewIndustryModal] = useState(false);
    const [newIndustryName, setNewIndustryName] = useState('');

    return (
        <div>
            <br/>
            <Container fluid>
                <Row>
                    <Col md={11}></Col>
                    <Col md={1}>

                        {isHandwaiPerson()&&<Button
                            className={'handwai-btn-create'}
                            onClick={() => {
                                setNewIndustryModal(true);
                            }}
                        >
                            Neu Industrie
                        </Button>}

                    </Col>
                </Row>
                <Modal
                    size="md"
                    variant={'dark'}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    animation={false}
                    show={newIndustryModal}
                    onHide={() => {
                        setNewIndustryModal(false);
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Neu Industrie</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form>
                            <Form.Group as={Row}>
                                <Col sm="3">
                                    <Form.Label>Name:</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Control
                                        className={''}
                                        type="text"
                                        placeholder="Screiben Sie neu Industrie Name hier"
                                        onChange={(e) => {
                                            setNewIndustryName(e.target.value);
                                        }}
                                    />
                                </Col>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            size="sm"
                            className={'handwai-btn-create'}
                            style={{width: '40%'}}
                            onClick={() => {
                                setNewIndustryModal(false);
                            }}
                        >
                            <X/>
                            &nbsp;&nbsp;Abbrechen
                        </Button>

                        <Button
                            style={{width: '40%'}}
                            size="sm"
                            block
                            className={'handwai-btn-green'}
                            onClick={() => {
                                if (newIndustryName.length !== 0) {
                                    setIndustries({industry_name: newIndustryName}).then((r) => r);
                                    setNewIndustryModal(false);
                                } else {
                                    alert('Sie haben leer Name gegeben.');
                                }
                            }}
                        >
                            &nbsp;&nbsp;Speichern
                        </Button>
                    </Modal.Footer>
                </Modal>
                &nbsp;&nbsp;

                <Row>
                    <Col>
                        <Accordion>
                            <Card className="handwai-dark">
                                <Card.Header>
                                    <Accordion.Toggle style={{justifyContent: 'center', width: '100%'}}
                                                      as={Card.Header}
                                                      className="handwai-btn-create"
                                                      eventKey="0">
                                        LV erfolgreich hochgeladen
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <AnalyseRequest lvstatus="Unknown"/>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Col>
                </Row>


                <Row>
                    <Col>
                        <Accordion>
                            <Card className="handwai-dark">
                                <Card.Header>
                                    <Accordion.Toggle style={{justifyContent: 'center', width: '100%'}}
                                                      as={Card.Header}
                                                      className="handwai-btn-create"
                                                      eventKey="0">
                                        Analyse in Vorbereitung
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <AnalyseRequest lvstatus="open"/>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Accordion>
                            <Card className="handwai-dark">
                                <Card.Header>
                                    <Accordion.Toggle style={{justifyContent: 'center', width: '100%'}}
                                                      as={Card.Header}
                                                      className="handwai-btn-create"
                                                      eventKey="0">
                                        Analyse in Bearbeitung
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <AnalyseRequest lvstatus="in-progress"/>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Col>
                </Row>


                <Row>
                    <Col>
                        <Accordion>
                            <Card className="handwai-dark">
                                <Card.Header>
                                    <Accordion.Toggle style={{justifyContent: 'center', width: '100%'}}
                                                      as={Card.Header}
                                                      className="handwai-btn-create"
                                                      eventKey="0">
                                        Analyse erfolgreich abgeschlossen
                                    </Accordion.Toggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey="0">
                                    <AnalyseRequest lvstatus="Completed"/>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </Col>
                </Row>

                <br/>
                <br/>
            </Container>
        </div>
    )
}

export default memo(AnalyseRequestPage);